import React from 'react';

import BackButton from '../../../../components/UI/BackButton';
import Button from '../../../../components/UI/Button';
import CheckListItem from '../../../../components/UI/CheckListItem';
import Layout from '../../../Layout';

import fccCss from '../FCC.module.scss';
import layoutCss from '../../../Layout/Layout.module.scss';
import setPlanCss from '../../../Widgets/SetPlan/SetPlan.module.scss';

interface PlanTool {
  heading: string;
  details: string;
  image: string;
}

interface PlanPerk {
  heading: string;
  details: string;
}

interface PlanDetailsProps {
  heading: string;
  subheading: string;
  buttonText: string;
  tools?: PlanTool[];
  perksHeading?: string;
  perks?: PlanPerk[];
  footer?: JSX.Element;
  onSelectPlan: () => void;
  onBackClick: () => void;
}

const PlanDetails = (props: PlanDetailsProps) => {
  return (
    <Layout>
      <BackButton onClick={props.onBackClick} />
      <div className={layoutCss.layoutWrapper}>
        <h1>{props.heading}</h1>
        <p>{props.subheading}</p>
        <div className={setPlanCss.invest}>
          <div className={setPlanCss.investInfoContainer}>
            {props.tools?.map((tool, index) => (
              <div className={setPlanCss.investInfo} key={index}>
                <img src={`../../../static/${tool.image}`} />
                <div>
                  <h2>{tool.heading}</h2>
                  <p>{tool.details}</p>
                </div>
              </div>
            ))}
          </div>
          <p className={setPlanCss.maxHeader}>
            {props.perksHeading || 'Protection and perks'}
          </p>
          {props.perks?.map((item, index) => {
            return (
              <div className={setPlanCss.maxInfo} key={index}>
                <CheckListItem>
                  <h2>{item.heading}</h2>
                  <p>{item.details}</p>
                </CheckListItem>
              </div>
            );
          })}
        </div>
        <Button
          text={props.buttonText}
          loading={false}
          onClick={() => props.onSelectPlan()}
        />
        <div className={fccCss.textButton} onClick={() => props.onBackClick()}>
          Go back
        </div>
        {props.footer && <div className={fccCss.footer}>{props.footer}</div>}
      </div>
    </Layout>
  );
};

export default PlanDetails;
